<template>
  <!-- タグ -->
  <div style="width: 100%;" v-if="!isLoading">
    <b-taglist class="tag-c">
      <template v-if="chatbotTags.length > 0">
        <b-tag type="is-info" v-for="(tag, idx) in chatbotTags" :key="idx + '-tag'">
          {{tag}}
        </b-tag>
      </template>
      <template v-else>
        <b-tag>
          タグ設定なし
        </b-tag>
      </template>
      <template v-if="autoCompleteTagList.length > 0 && isEdit">
        <div style="display: flex;">
          <select v-model="tag" class="select is-small">
            <option
              v-for="(auto, idx) in autoCompleteTagList"
              :key="idx + '-auto'"
              :value="auto"
              placeholder="タグを選択">
              {{auto}}
            </option>
          </select>
          <button class="button is-small" style="border-color: #000;"
            @click="addTag(tag)">
            <span class="mdi mdi-plus" style="border-color: #000;"></span>
          </button>
        </div>
      </template>
    </b-taglist>
  </div>
  <div v-else>
    <span class="mdi mdi-loading mdi-spin"></span>作成中です
  </div>
</template>

<script>
import {
  SITEMAP_ACTION_TYPE
} from '@/functions/users/sitemapFunc'
export default {
  props: {
    chatbot: {
      type: Object,
      required: true,
    },
    sitemapRootList: {
      type: Array,
      required: true
    },
    sitemapEmploymentList: {
      type: Array,
      required: true
    },
    isEdit: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      selectSitemapList: [],
      selectEmploymentList: [],
      sitemapListAll: [],
      employmentListAll: [],
      tag: null,
      isLoading: false,
    }
  },
  computed: {
    autoCompleteTagList () {
      let tags = []
      for (const sitemap of this.sitemapListAll) {
        for (const tag of sitemap.tag_list) {
          tags.push(tag.name)
        }
      }
      for (const employment of this.employmentListAll) {
        for (const tag of employment.tag_list) {
          tags.push(tag.name)
        }
      }
      return this.$_.uniq(tags)
    },
    chatbotTags () {
      let tags = []
      for (const sitemap of this.selectSitemapList) {
        for (const tag of sitemap.tag_list) {
          tags.push(tag.name)
        }
      }
      for (const employment of this.selectEmploymentList) {
        for (const tag of employment.tag_list) {
          tags.push(tag.name)
        }
      }
      return this.$_.uniq(tags)
    }
  },
  created () {
    this.init(this.chatbot)
  },
  watch: {
    sitemapRootList: {
      handler: function (val, oldVal) {
        this.init(this.chatbot)
      },
      deep: true
    },
    sitemapEmploymentList: {
      handler: function (val, oldVal) {
        this.init(this.chatbot)
      },
      deep: true
    },
  },
  methods: {
    init (chatbot) {
      // URLを挿入していく
      for (const root of this.sitemapRootList) {
        for (const sitemap of root.node_list) {
          for (const robo of sitemap.apply_robo_list.concat(sitemap.apply_minirobo_list)) {
            if (robo.data.bot_id === chatbot.bot_id) {
              this.selectSitemapList.push(sitemap)
            }
          }
          this.sitemapListAll.push(sitemap)
        }
      }
      // URLを挿入していく
      for (const employment of this.sitemapEmploymentList) {
        for (const robo of employment.apply_robo_list.concat(employment.apply_minirobo_list)) {
          if (robo.data.bot_id === chatbot.bot_id) {
            this.selectEmploymentList.push(employment)
          }
        }
        this.employmentListAll.push(employment)
      }
    },
    addTag (tag) {
      // 重複チェック
      if (this.$_.findIndex(this.chatbotTags, tag) >= 0) {
        alert('既に登録されているタグです。')
        return
      }
      if (this.$_.difference(this.sitemapListAll, this.selectSitemapList).length === 0
        &&
          this.$_.difference(this.employmentListAll, this.selectEmploymentList).length === 0
        ) {
          alert('既に登録されているタグです。')
          return
      }
      let isAdd = confirm('タグを追加することで連動する起動ページのタグと結びついて設置されます。\n追加してもよろしいですか？')
      if (isAdd) {
        this.isLoading = true
        let loadCount = 0
        let updateData = {
          update_list: [],
          action     : SITEMAP_ACTION_TYPE.ROBO_APPLY,
          is_mini    : false,
        }
        let robo = {
          data: {
            'pk'           : this.chatbot.bot_id,
            'name'         : this.chatbot.name,
            'bot_id'       : this.chatbot.bot_id,
            'scenario_name': this.chatbot.scenario_name,
          },
          is_mini: false
        }
        // 設定したタグの中で重複しているものを除いて抽出
        for (const sitemap of this.$_.difference(this.sitemapListAll, this.selectSitemapList)) {
          for (const t of sitemap.tag_list) {
            if (t.name === tag) {
              let updatePath = {
                target   : sitemap,
                robo     : [robo]
              }
              updateData.update_list.push(updatePath)
            }
          }
        }
        this.$store.dispatch('sitemap/updateSitemapNode', {
          update_data: updateData
        }).then(() => {
            loadCount++
            if (loadCount === 2) {
              this.isLoading = false
              this.tag = null
            }
          })
        updateData.update_list = []
        for (const employment of this.$_.difference(this.employmentListAll, this.selectEmploymentList)) {
          for (const t of employment.tag_list) {
            if (t.name === tag) {
              let updatePath = {
                target   : employment,
                robo     : [robo]
              }
              updateData.update_list.push(updatePath)
            }
          }
        }
        this.$store.dispatch('sitemap/updateSitemapEmployment', {
          update_data: updateData
        }).then(() => {
            loadCount++
            if (loadCount === 2) {
              this.isLoading = false
              this.tag = null
            }
          })
      } else {
        alert('追加をキャンセルいたしました。')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-c {
  flex-wrap: nowrap;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/ChatBotTags.vue